/* Klebende Kaufleiste der Produktseite.

   Zeigt sich, sobald der echte Kaufknopf aus dem Bild ist, und verschwindet,
   wenn er wieder erscheint. Ein `IntersectionObserver` statt eines
   Scroll-Zuhörers: Er meldet genau die Zustandswechsel und läuft nicht bei
   jedem Pixel mit.

   Nur auf dem Telefon. Auf dem Desktop steht die Kaufbox ohnehin im Bild,
   und eine Leiste über der Seite wäre dort nur eine Verdeckung. */
if (!customElements.get('tire-kaufleiste')) {
  customElements.define(
    'tire-kaufleiste',
    class TireKaufleiste extends HTMLElement {
      connectedCallback() {
        this.disconnectedCallback();
        this.schmal = window.matchMedia('(max-width: 749px)');
        this.ziel = document.getElementById(this.dataset.ziel);
        this.knopf = this.querySelector('button');
        if (!this.ziel || !this.knopf || !('IntersectionObserver' in window)) return;

        // The real button owns translated quantity labels and submission state.
        this.synchronisieren = () => {
          var beschriftung = this.ziel.querySelector('span');
          var text = (beschriftung || this.ziel).textContent.trim();
          if (text && this.knopf.textContent.trim() !== text) this.knopf.textContent = text;
          this.knopf.disabled = this.ziel.disabled || this.ziel.getAttribute('aria-disabled') === 'true';
          if (this.ziel.getAttribute('aria-busy') === 'true') this.knopf.setAttribute('aria-busy', 'true');
          else this.knopf.removeAttribute('aria-busy');
        };
        this.synchronisieren();
        this.zustand = new MutationObserver(this.synchronisieren);
        this.zustand.observe(this.ziel, {
          subtree: true, childList: true, characterData: true, attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'aria-busy']
        });
        // Forward through the source button so inventory checks and duplicate-submit
        // guards use the same click path as the main purchase control.
        this.kaufen = (event) => {
          event.preventDefault();
          this.synchronisieren();
          if (!this.knopf.disabled) this.ziel.click();
        };
        this.knopf.addEventListener('click', this.kaufen);
        this.zielSichtbar = true;

        this.beobachter = new IntersectionObserver(
          function (eintraege) {
            this.zielSichtbar = eintraege[0].isIntersecting;
            this.hidden = this.zielSichtbar || !this.schmal.matches;
          }.bind(this),
          /* Etwas Vorlauf: Die Leiste soll nicht erst auftauchen, wenn der
             Knopf schon weg ist, sondern wenn er den Rand streift. */
          { rootMargin: '-10px 0px 0px 0px', threshold: 0 }
        );
        this.beobachter.observe(this.ziel);

        /* Beim Drehen des Geräts kann aus schmal breit werden. */
        this.breiteGeaendert = () => {
          this.hidden = this.zielSichtbar || !this.schmal.matches;
        };
        if (this.schmal.addEventListener) {
          this.schmal.addEventListener('change', this.breiteGeaendert);
        }
      }

      disconnectedCallback() {
        if (this.beobachter) this.beobachter.disconnect();
        if (this.zustand) this.zustand.disconnect();
        if (this.knopf && this.kaufen) this.knopf.removeEventListener('click', this.kaufen);
        if (this.schmal && this.breiteGeaendert) this.schmal.removeEventListener('change', this.breiteGeaendert);
      }
    }
  );
}
